import { computed, ref } from 'vue'
import getApiClient from 'src/utils/getApiClient'

export type HeaderTownSearchResult = {
  name: string
  translit: string
  is_main_town: boolean
  name_translated: string
  translations: Record<string, string>
}

const MIN_QUERY_LENGTH = 3
const AUTOCOMPLETE_URL = '/api/town/autocomplete/'

export default function useHeaderTownSearch() {
  const searchQuery = ref('')
  const searchResults = ref<HeaderTownSearchResult[]>([])
  const isAutocompleteLoading = ref(false)

  const axios = getApiClient()
  let autocompleteRequestId = 0

  const isSearching = computed(() => searchQuery.value.length >= MIN_QUERY_LENGTH)

  function resetSearch() {
    searchQuery.value = ''
    searchResults.value = []
    isAutocompleteLoading.value = false
    autocompleteRequestId += 1
  }

  async function loadAutocompleteResults(query: string) {
    if (query.length < MIN_QUERY_LENGTH) {
      searchResults.value = []
      isAutocompleteLoading.value = false
      return
    }

    const requestId = ++autocompleteRequestId

    isAutocompleteLoading.value = true

    try {
      const response = await axios.get<HeaderTownSearchResult[]>(AUTOCOMPLETE_URL, {
        params: { query },
      })

      if (requestId !== autocompleteRequestId) {
        return
      }

      searchResults.value = response.data
    } catch {
      if (requestId === autocompleteRequestId) {
        searchResults.value = []
      }
    } finally {
      if (requestId === autocompleteRequestId) {
        isAutocompleteLoading.value = false
      }
    }
  }

  return {
    searchQuery,
    searchResults,
    isAutocompleteLoading,
    isSearching,
    loadAutocompleteResults,
    resetSearch,
  }
}
